import { ref, watch } from 'vue';
import axios from 'axios';

const isOpen = ref(false);

export function useGlobalSearch() {
    const users = ref([]);
    const search = ref('');
    const selected = ref(0);

    const toggle = () => {
        isOpen.value = !isOpen.value;
    };

    watch(users, (usersArray) => {
        if (usersArray.length && selected.value >= usersArray.length) {
            selected.value = usersArray.length - 1;
        }
    });

    const searchUsers = () => {
        axios
            .get(route('students.search', { search: search.value }))
            .then((response) => (users.value = response.data.users));

        // _.debounce(() => {
        // }, 100)
    };
    const selectUp = () => {
        selected.value = Math.max(0, selected.value - 1);
    };
    const selectDown = () => {
        selected.value = Math.min(users.value.length - 1, selected.value + 1);
    };

    const go = () => {
        if (users.value.length) {
            window.location = users.value[selected.value].url;
        }
    };
    const onEscape = (e) => {
        if (e.key === 'Esc' || e.key === 'Escape') {
            isOpen.value = false;
        }
    };

    return {
        isOpen,
        users,
        search,
        selected,
        toggle,
        searchUsers,
        selectUp,
        selectDown,
        go,
        onEscape,
    };
}
